import React, { useState } from "react";
import { Dropdown, Input, Space } from "antd";
import { DownOutlined } from "@ant-design/icons";

const SubscriptionDropdown = ({ value, onChange }) => {
  const [selected, setSelected] = useState(value || "");
  const [open, setOpen] = useState(false);
  const [customInput, setCustomInput] = useState(value || "");

  const items = [
    { key: "Monthly", label: "Monthly" },
    { key: "Quarterly", label: "Quarterly" },
    { key: "Yearly", label: "Yearly" },
  ];

  const handleMenuClick = ({ key }) => {
    setSelected(key);
    setCustomInput(key);
    onChange?.(key);
    setOpen(false);
  };

  const handleCustomInput = (e) => {
    const val = e.target.value;
    setCustomInput(val);
    setSelected(val);
    onChange?.(val);
  };

  return (
    <Dropdown
      open={open}
      onOpenChange={setOpen}
      menu={{
        items,
        onClick: handleMenuClick,
        selectable: true,
        selectedKeys: [selected],
      }}
      trigger={["click"]}
    >
      <Space style={{ width: "100%" }}>
        <Input
        allowClear
          size="large"
          placeholder="Select or type subscription"
          value={customInput}
          onChange={handleCustomInput}
          suffix={<DownOutlined onClick={() => setOpen(!open)} />}
        />
      </Space>
    </Dropdown>
  );
};

export default SubscriptionDropdown;
